import React from 'react';
import { Link } from 'react-router-dom';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <h1 className="text-2xl font-bold text-gray-900">
              <Link to="/">Honey The Agility Pony</Link>
            </h1>
            <nav className="hidden md:flex items-center space-x-4">
              <Link to="/" className="text-gray-700 hover:text-blue-600 px-3 py-2">Welkom</Link>
              <Link to="/over-ons" className="text-gray-700 hover:text-blue-600 px-3 py-2">Over ons</Link>
              <Link to="/showteam" className="text-gray-700 hover:text-blue-600 px-3 py-2">Showteam</Link>
              <Link to="/leesvoer" className="text-gray-700 hover:text-blue-600 px-3 py-2">Ons boek</Link>
              <a href="#contact" className="bg-blue-600 text-white px-4 py-2 rounded">Contact</a>
            </nav>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <footer className="bg-gray-800 text-white py-8" id="contact">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p>© 2024 Honey The Agility Pony.</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
